
export type GetTweetsType = typeof GetTweetsType[keyof typeof GetTweetsType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetTweetsType = {
  FOR_YOU: 'FOR_YOU',
  USER: 'USER',
  FOLLOW: 'FOLLOW',
  DETAIL: 'DETAIL',
} as const;
